import lightThemeUrl from 'primereact/resources/themes/lara-light-cyan/theme.css?url';
import darkThemeUrl from 'primereact/resources/themes/lara-dark-cyan/theme.css?url';

export const THEMES = {
  light: { name: 'light', url: lightThemeUrl, label: 'Claro' },
  dark: { name: 'dark', url: darkThemeUrl, label: 'Oscuro' },
};

export const STORAGE_KEY = 'app-theme';

export function getInitialTheme() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'dark' || stored === 'light') return stored;
  } catch {
    // localStorage may be unavailable (private mode, etc.)
  }
  return 'light';
}

export function applyTheme(themeName) {
  const theme = THEMES[themeName] ?? THEMES.light;
  document.querySelectorAll('link[data-prime-theme]').forEach((el) => el.remove());
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = theme.url;
  link.dataset.primeTheme = theme.name;
  document.head.appendChild(link);
  document.documentElement.setAttribute('data-theme', theme.name);
  try {
    localStorage.setItem(STORAGE_KEY, theme.name);
  } catch {
    // ignore
  }
}

export function toggleTheme(current) {
  return current === 'dark' ? 'light' : 'dark';
}